// extracted by mini-css-extract-plugin
module.exports = {"price":"Ty-z","onSale":"Uy-z"};